<template>
  <section class="content">
    <div class="row center-block">   
      <box>
          <!-- /.box-header -->
          <div slot="body">
            <div class="row">
              <div class="col-sm-6">
                <router-link class="btnNovaCategoria" :to="{ name: 'NovaCategoria'}">
                  <button class="btn btn-primary btnNovaCategoria" >
                    <i class="fa fa-plus paddingRight"></i>Nova Categoria
                  </button>
                </router-link>
                <router-link class="btnNovaCategoria" :to="{ name: 'orderCategoria', params: { categoriasFiltered }}">
                  <button class="btn btn-success btnNovaCategoria" >
                    <i class="fa fa-list-ol paddingRight"></i>Ordenar Categorias
                  </button>
                </router-link>
                <!--Arvore de categorias <vue-tree :tree-data="categorias" :options="options" @item-delete="excluirCategoria"></vue-tree> -->

              </div>
            </div>

            <ul class="nav nav-tabs">
              <li class="active" id="comum"><a href="javascript:;" @click="mudarAtivo('comum')">Categorias de Produtos Comuns</a></li>
              <li class="" id="adicionais"><a href="javascript:;" @click="mudarAtivo('adicionais')">Categoria de Adicionais</a></li>
            </ul>
            <br>

            <!--     CATG PROD COMUNS     -->
            <div v-show="tabAtiva == 'comum'">
              <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                      <thead>
                        <tr>
                          <th v-for="coluna in colunas">
                              <a href="javascript:;" @click="orderCategoria(coluna)" >{{coluna | ucwords}}</a>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="even" role="row" v-for="c in categoriasComunsFiltered">
                            <td>{{c.id}}</td>
                            <td class="sorting_1">{{c.nome}}</td>
                            <td><img :src="c.url_imagem" class="url_imagem"></td>
                            <td>
                              <i :class="'fa fa-circle ativo_'+c.ativo" aria-hidden="true" title=""></i>
                            </td>
                            <td>
                              <div class="grupo_btn_acoes">
                                <router-link :to="{name: 'editarCategoria', params: { id: c.id}}" class="btn_editar">
                                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                </router-link>
                                <i class="fa fa-trash-o btn_excluir" aria-hidden="true" @click="excluirCategoria(c.id)"></i>
                              </div>
                            </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                            <th v-for="coluna in colunas">
                                <a href="javascript:;" @click="orderCategoria(coluna)">{{coluna | ucwords}}</a>
                            </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!--     CATG PROD ADICIONAIS     -->
            <div v-show="tabAtiva == 'adicionais'">
              <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                      <thead>
                        <tr>
                          <th v-for="coluna in colunas">
                              <a href="javascript:;" @click="orderCategoria(coluna)" >{{coluna | ucwords}}</a>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="even" role="row" v-for="c in categoriasAdicionaisFiltered">
                            <td>{{c.id}}</td>
                            <td class="sorting_1">{{c.nome}}</td>
                            <td>
                              <i :class="'fa fa-circle ativo_'+c.ativo" aria-hidden="true" title=""></i>
                            </td>
                            <td>
                              <div class="grupo_btn_acoes">
                                <router-link :to="{name: 'editarCategoria', params: { id: c.id}}" class="btn_editar">
                                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                </router-link>
                                <i class="fa fa-trash-o btn_excluir" aria-hidden="true" @click="excluirCategoria(c.id)"></i>
                              </div>
                            </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                            <th v-for="coluna in colunas">
                                <a href="javascript:;" @click="orderCategoria(coluna)">{{coluna | ucwords}}</a>
                            </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
              <!-- /.box-body -->
          </div>
      </box>


    </div>
  </section>
</template>

<script>
import axios from 'axios'
import Box from './Box'

// import routes from '../../routes.js'

export default {
  name: 'Categorias',
  components: {
    'box': Box
  },
  data () {
    return {
      categorias: [],
      produtos: [],
      allCategories: [],
      colunas: ['id', 'nome', 'imagem', 'ativo', ''],
      order: {
        keys: '',
        sort: ''
      },
      tabAtiva: 'comum',
    }
  },
  created () {
    this.getCategorias()
    this.getProdutos()
  },
  filters: {
    ucwords (value) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    categoriasComunsFiltered () {
      let colecao = _.orderBy(this.allCategories, this.order.keys, this.order.sort)
      return _.filter(colecao, item => {
        return item.adicionais === false
      })
    },
    categoriasAdicionaisFiltered () {
      let colecao = _.orderBy(this.allCategories, this.order.keys, this.order.sort)
      return _.filter(colecao, item => {
        return item.adicionais === true
      })
    }
  },
  methods: {
    getCategorias () {
      axios.get(`${this.$store.state.api}categorias?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.allCategories = response.data
        // this.ajustarCategorias()
      })
    },
    ajustarCategorias () {
      for (var i = 0; i < this.allCategories.length; i++) {
        this.categorias.push({name: this.allCategories[i].nome, id: this.allCategories[i].id})
      }
      
      //  descomentar quando houver configuração de sub categorias
      /*for (var i = 0; i < this.allCategories.length; i++) {
        this.categorias.push({name: this.allCategories[i].nome, id: this.allCategories[i].id, children: []})
        for (var j = 0; j < this.allCategories[i].children.length; j++) {
          this.categorias[i].children.push({name: this.allCategories[i].children[j].nome, id: this.allCategories[i].children[j].id, children: []})
          for (var k = 0; k < this.allCategories[i].children[j].children.length; k++) {
            this.categorias[i].children[j].children.push({name: this.allCategories[i].children[j].children[k].nome, id: this.allCategories[i].children[j].children[k].id})
          }
        }
      } */
    },
    getProdutos () {
      axios.get(`${this.$store.state.api}produtos?empresa=${this.$store.state.empresa_fb_id}`).then(response => {
        this.produtos = response.data
      })
    },
    excluirCategoria (id) {
      if (!this.verificaProdutos(id) || id === 1 || id === 2){
        this.$swal(
        'Ops',
        'Esta categoria não pode ser excluida, pois possui produtos associados a ela!',
        'error'
      )
      } else {
        this.$swal({
          title: 'Tem certeza que deseja excluir?',
          text: "Você não poderá reverter isto!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, delete!',
          cancelButtonText: 'Não, cancele!',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          buttonsStyling: false,
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            axios.post(this.$store.state.api+'categorias/delete', {
              'id': id
              }).then(response => {
                if(response.data.success) {
                  this.getCategorias()
                  this.$swal({
                    position: 'top-end',
                    type: 'success',
                    title: 'Excluída com sucesso',
                    showConfirmButton: false,
                    timer: 1500
                  })          
                } else {
                  this.$swal(
                    'Ops',
                    'Ocorreu um erro na exclusão da categoria.',
                    'error'
                  )
                }
              })
            
          // result.dismiss can be 'cancel', 'overlay',
          // 'close', and 'timer'
          }
        })
      }
    },
    mudarAtivo (id) {
      console.log('id => ', id)
      $('.active').removeClass('active')
      document.getElementById(id).className = 'active'
      this.tabAtiva = id
    },
    //verifica se há categorias filhas
    /*verificaFolha (id) {
      for (var i = 0; i < this.allCategories.length; i++) {
        if (id === this.allCategories[i].pai) {
          return false
        } else {
          for (var j = 0; j < this.allCategories[i].children.length; j++) {
            if (id === this.allCategories[i].children[j].pai) {
              return false
            } else {
              for (var k = 0; k < this.allCategories[i].children[j].children.length; k++) {
                if (id === this.allCategories[i].children[j].children[k].pai) {
                  return false
                }
              }
            }
          }
        }
      }
      return true
    },*/
    verificaProdutos (id) {
      for (var i = 0; i < this.produtos.length; i++) {
        if (this.produtos[i].categorias_id === id) {
          return false
        }
      }
      return true
    },
    orderCategoria (coluna) {
      this.order.keys = coluna
    //   console.log(this.order.keys)
      this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc'
    //   console.log(this.order.sort)
    }
  }
}
</script>
<style>
.btnNovaCategoria{
    width: 33%;
    margin-bottom: 5%;
}
.grupo_btn_acoes {
  display: flex;
  font-size: 170%;
}
.btn_editar {
  margin-right: 4%;
  color: #333333
}
.btn_excluir {
  margin-top: 2%
}
.btn_editar:hover {
  color: #00C0EF!important;
  cursor:pointer;
}
.btn_excluir:hover {
  color: #DD4B39;
  cursor:pointer;
}
.ativo_true {
  color: green
}
.ativo_false {
  color: #DD4B39
}
.paddingRight {
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// Categorias.vue?4d816363